import { ChevronDown } from 'pcln-icons';
import React from 'react';
import styled from 'styled-components';
import { Button } from '../../Button/Button';
import { getPaletteColor } from '../../utils/utils';
import { ChipContent } from '../ChipContent/ChipContent';
import { ChipContentWrapper } from '../ChipContentWrapper';
const ChipButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "ButtonChip__ChipButton",
  componentId: "sc-pjuaz2-0"
})(["background-color:transparent;border:none;padding:0;&:hover{background-color:transparent;}&:focus-visible{box-shadow:none;outline-offset:2px;outline:3px solid ", ";}&:focus-visible > ", "{border-color:", ";}"], getPaletteColor('base'), ChipContentWrapper, getPaletteColor('base'));
const getTitle = ({
  disabled,
  expanded
}) => disabled ? 'Disabled' : expanded ? 'Collapse' : 'Expand';
/**
 * @public
 */
export const ButtonChip = React.forwardRef(({
  color = 'primary',
  width,
  id,
  m,
  disabled,
  expanded,
  children,
  onClick,
  label,
  showActionIcon,
  variation = 'outline',
  ...props
}, ref) => React.createElement(ChipButton, {
  color: color,
  width: width,
  id: id,
  "data-testid": id,
  ref: ref,
  disabled: disabled,
  onClick: onClick,
  "aria-expanded": expanded,
  m: m
}, React.createElement(ChipContent, {
  label: label,
  disabled: disabled,
  selected: expanded,
  action: showActionIcon && {
    Icon: ChevronDown,
    title: getTitle({
      disabled,
      expanded
    })
  },
  variation: variation,
  ...props
}, children)));
ButtonChip.displayName = 'ButtonChip';